import React from "react";
import { Link } from "react-router-dom";
import { Plane, Repeat, MapPin, ArrowUpRight, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const icons = {
  "one-way": Plane,
  "round-trip": Repeat,
  "tour": MapPin,
};

const Services = () => {
  const { t } = useLang();

  const goBook = () => {
    const el = document.getElementById("booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 sm:py-32 bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <p className="text-[#2E4F4F] text-xs uppercase tracking-[0.3em] mb-4">
              {t.services.eyebrow}
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1F24] max-w-xl tracking-tight">
              {t.services.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {t.services.items.map((item, idx) => {
            const Icon = icons[item.id];
            const isFeatured = idx === 0;
            return (
              <div
                key={item.id}
                data-testid={`service-card-${item.id}`}
                className={`group relative bg-white border border-[#EAE6DF] p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
                  isFeatured ? "md:col-span-2 md:row-span-1" : ""
                }`}
              >
                <div className="flex items-start justify-between mb-12">
                  <div className="w-12 h-12 bg-[#1A1F24] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#C6A87C]" />
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-[#4A5568] group-hover:text-[#2E4F4F] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
                </div>

                <h3 className="font-serif text-2xl sm:text-3xl text-[#1A1F24] mb-4 leading-tight">
                  {item.name}
                </h3>
                <p className="text-[#4A5568] text-base leading-relaxed mb-8 max-w-md">
                  {item.desc}
                </p>

                <div className="flex items-center justify-between border-t border-[#EAE6DF] pt-6">
                  <span className="text-xs uppercase tracking-[0.2em] text-[#C6A87C] font-semibold">
                    {item.from}
                  </span>
                  <button
                    data-testid={`service-book-${item.id}`}
                    onClick={goBook}
                    className="text-xs uppercase tracking-[0.2em] text-[#1A1F24] hover:text-[#2E4F4F] transition-colors"
                  >
                    →
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            to="/catalog"
            data-testid="view-full-catalog"
            className="group inline-flex items-center gap-3 border border-[#1A1F24] hover:bg-[#1A1F24] hover:text-white text-[#1A1F24] px-8 py-4 text-xs uppercase tracking-[0.25em] transition-all"
          >
            {t.nav.catalog}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
